import { notification, Popover } from "antd";
import ArrowDownWComponent from "components/icons/ArrowDownBlue";
import { logoutUser } from "containers/app/utils";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import ManageAccess from "../../../../components/common/ManageAccess/manageAccess";
import { ROLE } from "../../../../constants/phase";
import { Hamburger, Logo } from "../../../icons";
import AccessControl from "../../AccessControl/accessControl";

const SuperAdminHeader = (props) => {
  const { fetchMe, removeIp, clientSetting, entityId, role } = props;

  const [userId] = useState(localStorage.getItem("__uid"));
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);
  const [userData, setUserData] = useState({});
  const [darkTheme, setDarkTheme] = useState(false);
  const [permitted, setPermitted] = useState([]);
  const [loggerDetails, setLoggerDetails] = useState([]);
  const [payload, setPayload] = useState({
    isAllNotificationSeen: true,
    markAllRead: false,
    id: "",
  });

  const showDrawer = () => {
    setVisible(true);
  };
  const fetchData = async () => {
    const { value } = await fetchMe();
    setUserData(value.data);
    setPermitted(value?.data?.permissions || []);
  };

  const fetchLoggerDetails = async () => {
    const { fetchLoggerDetails } = props;
    const { value } = await fetchLoggerDetails({
      limit: 20,
      activePage: 1,
    });
    if (value.success) {
      setLoggerDetails(value);
    }
  };

  const removeIP = async () => {
    // function for removing token for login limit functionality
    const { value } = await removeIp({
      userId: localStorage.getItem("__uid"),
      ipToken: localStorage.getItem("authToken"),
      opsEmail: localStorage.getItem("opsEmail") ? localStorage.getItem("opsEmail") : undefined,
    });
    logoutUser(navigate);
  };

  const updateLoggerDetails = async () => {
    const { updateLoggerDetails } = props;
    const { value } = await updateLoggerDetails({
      payload,
    });
    if (value.status) {
      fetchLoggerDetails();
    }
  };

  useEffect(() => {
    fetchData();
    // fetchLoggerDetails();
  }, []);

  useEffect(() => {
    if (!payload.isAllNotificationSeen || payload.markAllRead || payload.id) {
      updateLoggerDetails();
    }
  }, [payload.isAllNotificationSeen, payload.id, payload.markAllRead]);

  const name = userData?.name || "";

  const AvatarContent = (
    <div className="avatart-content-header">
      <ul>
        <AccessControl code="user_management" page="profile-dropdown">
          <ManageAccess value={role === ROLE.SUPER_ADMIN}>
            <li>
              <button onClick={() => navigate("/overview")}>Overview</button>
            </li>
          </ManageAccess>
        </AccessControl>
        <AccessControl code="user_management" page="profile-dropdown">
          <ManageAccess value={role === ROLE.SUPER_ADMIN}>
            <li>
              <button onClick={() => navigate("/organization-management")}>Organization Management</button>
            </li>
          </ManageAccess>
        </AccessControl>
        <AccessControl code="user_management" page="profile-dropdown">
          <ManageAccess value={role === ROLE.SUPER_ADMIN}>
            <li>
              <button onClick={() => navigate("/workspace-management")}>Workspace Management</button>
            </li>
          </ManageAccess>
        </AccessControl>
        <AccessControl code="user_management" page="profile-dropdown">
          <ManageAccess value={role === ROLE.SUPER_ADMIN}>
            <li>
              <button onClick={() => navigate("/user-management")}>User Management</button>
            </li>
          </ManageAccess>
        </AccessControl>

        <AccessControl code="user_management" page="profile-dropdown">
          <ManageAccess value={role === ROLE.SUPER_ADMIN}>
            <li>
              <button onClick={() => navigate("/ops-management")}>Ops Management</button>
            </li>
          </ManageAccess>
        </AccessControl>

        <AccessControl code="permission_management" page="profile-dropdown">
          <li>
            <button onClick={() => navigate("/permission-management")}>Roles and permissions</button>
          </li>
        </AccessControl>
        <AccessControl code="settings" page="profile-dropdown">
          <li>
            <button onClick={() => navigate("/configuration/category")}>Configuration</button>
          </li>
          {/* ) : null} */}
        </AccessControl>
        <li>
          <button className="logoutBtn" onClick={removeIP}>
            Logout
          </button>
        </li>
      </ul>
    </div>
  );

  useEffect(() => {
    const theme = localStorage.getItem("_th") === "dark-theme" ? true : false;
    setDarkTheme(theme);
  }, []);

  useEffect(() => {
    const theme = !darkTheme ? "data-theme" : "dark-theme";
    document.body.className = theme;
    localStorage.setItem("_th", theme);
  }, [darkTheme]);

  const profileNotification = (message) => {
    notification.open({
      message: message,
    });
  };

  return (
    <>
      <header className="header-container">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-5">
              <div className="left-logo-container">
                <div className="header-logo-block">
                  <Link to={"/"} className="header-logo">
                    <Logo />
                  </Link>
                </div>
                <div className="header-dropdown dropdown mobile-hide">
                  <span className="sml-rnd--text">{"ORGS"}</span>
                  <Popover trigger="hover" placement="bottom" className="headerDowndownitems--tm">
                    <span className="filter-dropdown-trigger">
                      {/* <img src={selectedEntity?.logo || ""} /> */}
                      {"All Org"}
                    </span>
                    <ArrowDownWComponent className="arrow-down--tm" />
                  </Popover>
                </div>
              </div>
            </div>
            <div className="col-7">
              <div className="right-menu-container">
                <div className="top__navigation--hamburger">
                  <button className="btn btn__hamburger" onClick={showDrawer}>
                    <Hamburger />
                  </button>
                </div>
                <ul className="desktop-menu">
                  <>
                    <li>
                      <Link to="/overview" className={pathname === "/overview" ? "active" : ""}>
                        Overview
                      </Link>
                    </li>
                    <li>
                      {" "}
                      <Link
                        to={"/organization-management"}
                        className={pathname === "/organization-management" ? "active" : ""}
                      >
                        Organizations
                      </Link>
                    </li>{" "}
                    <li>
                      {" "}
                      <Link to={"/user-management"} className={pathname === "/user-management" ? "active" : ""}>
                        Users
                      </Link>
                    </li>{" "}
                    <li>
                      <Link to={"/ops-management"} className={pathname === "/ops-management" ? "active" : ""}>
                        Ops
                      </Link>
                    </li>
                  </>
                </ul>
                <div className="header-avatar d-flex">
                  <Popover
                    content={AvatarContent}
                    overlayClassName="header-pop-avatar"
                    trigger="click"
                    placement="bottomRight"
                    className="header-inline-avatart-items"
                  >
                    <div className="profile-img">
                      {name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")}
                    </div>
                    <div className="avatar-desc">
                      <div className="profiletxt-sec">
                        <p className="profile-txt">{userData?.name}</p>
                        <p className="role-font-small">{role}</p>
                      </div>
                    </div>
                  </Popover>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {userData?.showAnalyticsMessage && (
        <React.Fragment>
          <div className="alert-msg-container">Data unavailable due to inactivity or content auto-deletion</div>
          <div className="blank-msg-space"></div>
        </React.Fragment>
      )}
    </>
  );
};
export default SuperAdminHeader;
